import {config, cookies, decrypt} from 'helpers';
import {ApiError, NetworkError} from './api-errors';
import {Buffer} from 'buffer';
import {AnyObject} from 'types';

const headers = {
  'Authorization': 'Basic ' + Buffer.from('successwizard' + ':' + 'XkInJp9kLQ92je43YQA6').toString('base64'),
  'content-type': 'application/json; charset=UTF-8'
};

const host = config.development ? '' : `https://${config.domain}`;

export async function api(url: string, payload: AnyObject = {}, options?: AnyObject) {
  const body = JSON.stringify({
    app: config.app,
    device: 'web',
    deviceId: config.deviceId,
    version: '2.0',
    ...prepare(JSON.parse(JSON.stringify(payload))),
    ...token()
  }).replace(/\//g, '\\/');

  try {
    // url = url.replace(/\/$/, "")
    // const res = await window.fetch(`http://localhost/o/webservices-portlet/rest/mobile${url}`, {
    const res = await window.fetch(`${host}/o/webservices-portlet/rest/mobile${url}`, {
      body,
      method: 'post',
      mode: 'cors',
      headers,
      ...options
    });
    if (res.status === 200) {
      const data = await res.json();
      if (data.errors?.length) {
        data.error = data.errors.map((e: AnyObject) => e.message).join(', ');
      }
      if (data.error && data.error !== 'success') {
        throw new ApiError({
          error: data.error,
          payload,
          url
        });
      }
      return data;
    } else {
      throw new ApiError({
        error: new Error('Api error'),
        payload,
        url,
        code: res.status
      });
    }
  } catch (error) {
    throw error instanceof ApiError ? error : new NetworkError(url);
  }
}

export function token() {
  if (cookies.get('token')) {
    return {token: decrypt(cookies.get('token') ?? '')};
  }
}

function prepare(object: AnyObject) {
  for (const key in object) {
    if (typeof object[key] === 'string') {
      object[key] = object[key].replace(/"/g, '\"');
    } else if (typeof object[key] === 'object') {
      object[key] = prepare(object[key]);
    }
  }
  return object;
}
